<template>
    <vx-card title="Edit Package">
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span> Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" v-model="packageName" />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Count</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input min="0" class="w-full" type="number" v-model="packageCount" />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Gift Count</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input min="0" class="w-full" type="number" v-model="packageGiftCount" />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Package Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <v-select data-vv-validate-on="blur"  name="packageType_name"
                    v-model="selectedPackageType" v-validate="'required'" label="packageTypeName" :options="packageTypeOptions"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Products</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">

                <v-select multiple :closeOnSelect="false" v-model="selectedProducts" :options="productOptions"
                    name="platform_name" label="productName" :dir="$vs.rtl ? 'rtl' : 'ltr'" /><br>


            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Platform</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">

                <v-select data-vv-validate-on="blur" placeholder="Select your platform *" name="platform_name"
                    v-model="selectedPlatform" v-validate="'required'" label="platformName" :options="platformOptions"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />

            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Duration(by month)</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input min="0" class="w-full" type="number" v-model="packageDuration" />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Price</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" type="number" v-model="packagePrice" />
            </div>
        </div>




         <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Currency</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <v-select data-vv-validate-on="blur"  name="packageType_name"
                    v-model="selectedCurrency" v-validate="'required'" label="code" :options="currencyOptions" />
            </div>
        </div>



        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea class="w-full" v-model="packageDescription" />
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Status</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-switch v-model="packageStatus" />   
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button @click="editPackage" class="mr-3 mb-2">Save</vs-button>
                <vs-button color="warning" type="border" class="mb-2"
                    @click="() => $router.push(`/packages-list`).catch(() => {})">Cancel</vs-button>
            </div>
        </div>
    </vx-card>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        components: {
            'v-select': vSelect
        },
        created() {
            this.getCurrencies()
            
            

            this.$store.state.product.allPackages.forEach(element => {
                if(element.id == this.$route.params.packageId){
                    
                   

                }
            });
        },
        data() {
            return {
                packageName: '',
                packageCount: '',
                packageGiftCount: '',
                packagePrice: '',
                packageDescription: '',
                packageDuration: '',
                selectedPlatform: '',
                selectedProducts: '',
                selectedPackageType: '',
                selectedCurrency:'',
                currencyOptions:[
                    {
                    currencyId:'',
                    currencyName:''
                    }
                ],
                platformOptions: [{
                        platformName: "Android",
                        platformCode: "1"
                    },
                    {
                        platformName: "IOS",
                        platformCode: "2"
                    },
                    {
                        platformName: "Web API",
                        platformCode: "3"
                    },
                    {
                        platformName: "Both Android & IOS",
                        platformCode: "4"
                    },
                ],
                packageTypeOptions: [{
                        packageTypeName: "Free",
                        packageTypeCode: "1"
                    },
                    {
                        packageTypeName: "Standart",
                        packageTypeCode: "2"
                    },
                    {
                        packageTypeName: "Pro",
                        packageTypeCode: "3"
                    },
                ],
                productOptions: [],
                packageStatus : true
            }
        },
        methods: {
            getCurrencies(){
                this.$store.dispatch('product/getCurrencies')
                 .then((response) => {
                       this.currencyOptions = response.data;
                       this.getAllProducts()
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
            },
            getAllProducts() {
                this.$store.dispatch('product/getAllProducts')
                    .then((response) => {
                        response.data.forEach(element => {
                            const product = {}
                            product["productId"] = element.id;
                            product["productName"] = element.productName;
                            this.productOptions.push(product)

                        });
                        this.getPackage()
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
            },
            getPackage() {
                this.$store.dispatch('product/getPackage', this.$route.params.packageId)
                    .then((response) => {
                        this.packageName = response.data.data.name
                        this.packageCount = response.data.data.count
                        this.packageGiftCount = response.data.data.giftCount
                        this.selectedPackageType = this.packageTypeOptions.find(o => o.packageTypeCode == response.data.data.packageType);
                        this.selectedPlatform = this.platformOptions.find(o => o.platformCode == response.data.data.packagePlatform);
                        this.selectedProducts = response.data.data.productPackages
                        this.packagePrice = response.data.data.price
                        this.packageDescription = response.data.data.description
                        this.packageDuration = response.data.data.periodMonth
                        this.packageStatus = response.data.data.isActive
                        const temp = this.currencyOptions.filter(x => x.id == response.data.data.currencyId)
                        this.selectedCurrency = temp[0]
                    })
                    .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    })
            },
            editPackage(){
                this.$vs.loading()
                const payload = {}
                
                payload["Id"] = this.$route.params.packageId
                payload["Name"] = this.packageName
                payload["Count"] = this.packageCount
                payload["giftCount"] = this.packageGiftCount
                payload["Description"] = this.packageDescription
                payload["Price"] = this.packagePrice
                payload["PeriodMonth"] = this.packageDuration
                payload["PackagePlatform"] = this.selectedPlatform.platformCode
                payload["PackageType"] = this.selectedPackageType.packageTypeCode
                payload["isActive"] = this.packageStatus
                payload["currencyId"] = this.selectedCurrency.id
                payload["ProductPackages"] = []
                this.selectedProducts.forEach( element => {
                    const temp = {}
                    
                    temp ["ProductId"] = element.productId
                    payload["ProductPackages"].push(temp);
                })


                this.$store.dispatch('product/editPackage',payload)
                .then(response => {
                     this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Successfull',
                            text: response.data.message,
                            iconPack: 'feather',
                            icon: 'icon-check-circle',
                            color: 'success'
                        })
                        setTimeout(()=> this.$router.push('/packages-list'), 500)
                })
                .catch(error =>{
                    this.$vs.loading.close()
                        this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                })
            },

          
        }
    }
</script>

<style>

</style>